import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import Time from "react-time-format";
import swal from "sweetalert";
import "./Switch.css";

class FillDetailKoga extends React.Component {
  componentDidMount() {
    if (localStorage.getItem("product")) {
      swal({
        title: "ببورە",
        text: "تکایە زیادکردنی کاڵا دانەخراوە دایبخە بۆ پاراستنی رەسیدی کاڵاکەت",
        icon: "error"
      });
    }
  }
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const {
              G_frosht,
              AddProChange,
              G_zhmaraysht,
              G_karton,
              G_darzan,
              G_nrx,
              G_naweSht,
              G_rezha,
              G_DarzanChange,
              G_CartonChange,
              G_tofirstInputINRent,
              G_zhmara,
              G_createNewPage,
              G_mob,
              G_nawe_barez,
              G_zh_barez,
              G_zh_wasl,
              G_zh_wasl_katy,
              G_anotherInputWakil,
              G_open,
              G_getWaslDataBySearchRent,
              G_getkoygahty,
              G_getProductDataBySearchRent,
              G_wasl,
              G_search_wakil,
              G_search,
              G_del_dis,
              G_save,
              G_togler,
              G_saveDetail,
              G_joripara,
              G_wargr,
              G_nrx_dolar,
              G_nrx_dinarr,
              G_nrx_niwkarton,
              G_nrx_kmtrdadarzan,
              G_rasidKarton,
              G_search_wasl,
              G_date,
              G_qazanj,
              G_kren,
              G_nrxkaton,
              G_setSearchEmptyRentWakil,
              G_setSaletSearchEmty,
              W_wakelakan,
              toanotherInput,
              G_nrxchange,
              G_inputtogler,
              G_table,
              OnChangeSwitch_G,
              OnChangeSwitch_G_IQD,
              G_Nrx_J_T_check,
              G_Nrx_IQD_check,
              G_Dolar2
            } = value;

            const wakilakan = W_wakelakan.filter((user) => {
              return user.Name.includes(G_nawe_barez);
            }).map((item, index) => {
              if (G_frosht == "فرۆشتنی ڕاستەوخۆ") {
                return null;
              } else {
                return <option key={index}>{item.Name}</option>;
              }
            });
            return (
              <>
                <div style={{ marginTop: "3.5em" }}>
                  <form>
                    <div
                      className="row text-warning font-weight-bold f4"
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <div className="col-3 form-inline">
                        <div className="col-7">
                          <label>:ناوی وەرگر</label>
                          <select
                            disabled={G_del_dis == true ? true : null}
                            className={`form-control text-right font-weight-bold selectpicker pull-right ${G_wargr == "یوسف"
                              ? "bg-success text-white"
                              : `${G_wargr == "ئەنوەر"
                                ? "bg-danger text-white"
                                : ""
                              }`
                              } `}
                            onChange={AddProChange}
                            name="G_wargr"
                            value={G_wargr != null ? G_wargr : ""}
                          >
                            <option className="ml5">ناوی وەرگر</option>
                            <option>ئەنوەر</option>
                            <option>یوسف</option>
                          </select>
                        </div>
                        <div className=" col-5">
                          <label>:جۆری دراو</label>
                          <select
                            className={`form-control text-right font-weight-bold selectpicker pull-right ${G_joripara == "دۆلار"
                              ? "bg-success text-white"
                              : `${G_joripara == "دینار"
                                ? "bg-danger text-white"
                                : ""
                              }`
                              } `}
                            onChange={AddProChange}
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? G_anotherInputWakil(event)
                                : null
                            }
                            name="G_joripara"
                            value={G_joripara != null ? G_joripara : ""}
                          >
                            <option
                              className="ml5"
                              disabled={G_joripara != null ? true : null}
                            >
                              جۆری دراو
                            </option>
                            <option
                              disabled={G_joripara == "دینار" ? true : null}
                            >
                              دۆلار
                            </option>
                            <option
                              disabled={G_joripara == "دۆلار" ? true : null}
                            >
                              دینار
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-2 text-right ">
                        <div className="form-group">
                          <label>:تەلەفۆن</label>
                          <input
                            type="number"
                            disabled={G_del_dis == true ? true : null}
                            value={G_mob}
                            name="G_mob"
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? G_anotherInputWakil(event)
                                : null
                            }
                            onChange={AddProChange}
                            className={`form-control text-right font-weight-bold ${G_frosht == "فرۆشتنی وەکیل"
                              ? "bg-success text-white"
                              : `${G_frosht == "فرۆشتنی ڕاستەوخۆ"
                                ? "bg-danger text-white"
                                : ""
                              }`
                              }`}
                          />
                        </div>
                      </div>
                      <div className="col-2 text-right">
                        <div className="form-group">
                          <label>:گەڕان</label>
                          <select
                            disabled={G_del_dis == true ? true : null}
                            className={`form-control  text-right font-weight-bold selectpicker pull-right ${G_frosht == "فرۆشتنی وەکیل"
                              ? "bg-success text-white"
                              : `${G_frosht == "فرۆشتنی ڕاستەوخۆ"
                                ? "bg-danger text-white"
                                : ""
                              }`
                              }`}
                            onChange={AddProChange}
                            name="G_nawe_barez"
                            value={G_nawe_barez}
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? G_anotherInputWakil(event)
                                : null
                            }
                          >
                            <option className="ml5">گەڕان</option>
                            {wakilakan}
                          </select>
                        </div>
                      </div>
                      <div className="col-2 text-right">
                        <div className="form-group">
                          <label>:بەڕێز</label>
                          <input
                            type="text"
                            disabled={G_del_dis == true ? true : null}
                            value={G_nawe_barez}
                            name="G_nawe_barez"
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? G_anotherInputWakil(event)
                                : null
                            }
                            onChange={AddProChange}
                            className={`form-control text-right font-weight-bold ${G_frosht == "فرۆشتنی وەکیل"
                              ? "bg-success text-white"
                              : `${G_frosht == "فرۆشتنی ڕاستەوخۆ"
                                ? "bg-danger text-white"
                                : ""
                              }`
                              }`}
                          />
                        </div>
                      </div>
                      <div className="col-3 text-right">
                        <div className="row">
                          <div className="col-3">
                            <div className="form-group">
                              <label>:وەکیل</label>
                              <input
                                type="text"
                                value={G_zh_barez > 0 ? G_zh_barez : ""}
                                disabled={
                                  G_del_dis == true ||
                                  G_search_wakil == true ||
                                    G_frosht == "فرۆشتنی ڕاستەوخۆ" ||
                                    G_frosht == null
                                    ? true
                                    : null
                                }
                                name="G_zh_barez"
                                onKeyPress={(event) =>
                                  event.key == "Enter"
                                    ? G_anotherInputWakil(event)
                                    : null
                                }
                                onChange={AddProChange}
                                className={`form-control text-right font-weight-bold ${G_frosht == "فرۆشتنی وەکیل"
                                  ? "bg-success text-white"
                                  : `${G_frosht == "فرۆشتنی ڕاستەوخۆ" ? "" : ""
                                  }`
                                  }`}
                              />
                            </div>
                          </div>
                          <div className="col-2">
                            <button
                              onClick={G_setSearchEmptyRentWakil}
                              disabled={G_del_dis == true ? true : null}
                              onKeyPress={(event) =>
                                event.key == "Enter"
                                  ? toanotherInput(event)
                                  : null
                              }
                              className="btn btn-dark mt4"
                            >
                              <i
                                onClick={G_setSearchEmptyRentWakil}
                                className="fas fa-search-plus"
                              ></i>
                            </button>
                          </div>
                          <div className="col-7">
                            <select
                              disabled={G_del_dis == true ? true : null}
                              className={`form-control text-right font-weight-bold selectpicker pull-right mt4 ml3 ${G_frosht == "فرۆشتنی وەکیل"
                                ? "bg-success text-white"
                                : `${G_frosht == "فرۆشتنی ڕاستەوخۆ"
                                  ? "bg-danger text-white"
                                  : ""
                                }`
                                }`}
                              onChange={AddProChange}
                              onKeyPress={(event) =>
                                event.key == "Enter"
                                  ? toanotherInput(event)
                                  : null
                              }
                              name="G_frosht"
                              value={G_frosht != null ? G_frosht : ""}
                            >
                              <option className="ml5">جۆری فرۆشتن</option>
                              <option> فرۆشتنی وەکیل</option>
                              <option> فرۆشتنی ڕاستەوخۆ</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div className="row">
                    <div className="col-3">
                      <div className="row">
                        <div
                          className={`${G_togler == true ? "col-10" : "col-7"
                            } pt2  tc`}
                        >
                          {G_togler == false ? (
                            <>
                              {G_search_wasl == true || G_save == true ? (
                                <p className="font-weight-bold bg-white">
                                  <Time
                                    value={G_wasl.date}
                                    format="YYYY-MM-DD"
                                    style={{ color: "black" }}
                                  />
                                </p>
                              ) : (
                                <p className="font-weight-bold bg-white">
                                  <Time
                                    value={Date.now()}
                                    format="YYYY-MM-DD"
                                    style={{ color: "black" }}
                                  />
                                </p>
                              )}
                            </>
                          ) : (
                            <input
                              type="datetime-local"
                              name="G_date"
                              value={G_date}
                              onChange={AddProChange}
                              className="form-control text-right font-weight-bold tc btn btn-info"
                              style={{ margin: "0px 8px" }}
                            />
                          )}
                        </div>
                        {G_togler == true ? null : (
                          <div className="col-3">
                            <label className="text-warning font-weight-bold f4">
                              :بەروار{" "}
                            </label>
                          </div>
                        )}
                        <div className="col-2">
                          <button
                            onClick={G_inputtogler}
                            disabled={G_del_dis == true ? true : null}
                            className="btn btn-info"
                          >
                            <i clasName="far fa-calendar-alt white "></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="row">
                        <div className="col-6 pt2  tc">
                          {G_togler == true ? null : (
                            <>
                              {G_search_wasl == true ? (
                                <p className="font-weight-bold bg-white">
                                  <Time
                                    value={G_wasl.date}
                                    format="hh:mm:ss"
                                    style={{ color: "black" }}
                                  />
                                </p>
                              ) : (
                                <p className="font-weight-bold bg-white">
                                  <Time
                                    value={Date.now()}
                                    format="hh:mm:ss"
                                    style={{ color: "black" }}
                                  />
                                </p>
                              )}
                            </>
                          )}
                        </div>
                        <div className="col-6">
                          <label className="text-warning font-weight-bold f4">
                            :کات{" "}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="col-3">
                      <h4 className="text-warning animate__animated animate__heartBeat animate__repeat-3">
                        گەڕانەوەی کاڵا
                      </h4>
                    </div>
                    <div className="col-2 ">
                      <div className="row">
                        <div className="col-6">
                          <input
                            type="number"
                            onChange={AddProChange}
                            value={G_zh_wasl}
                            disabled={G_open == true ? true : null}
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? G_getWaslDataBySearchRent(event)
                                : null
                            }
                            name="G_zh_wasl"
                            className="form-control text-right font-weight-bold px-0 bg-danger text-white"
                          />
                        </div>
                        <div className="col-6">
                          <label className="text-warning font-weight-bold f4">
                            :پسوولە{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-1 form-inline">
                      <h4 className="font-weight-bold bg-success text-white">
                        {G_zh_wasl_katy}
                      </h4>
                    </div>
                    {/* <div className='col-2'>

                </div> */}
                  </div>
                  <div className="row">
                    <div className="col-4"></div>
                    <div className="col-5">
                      <div className="row">
                        <div
                          className={`col-1 text-${!G_Nrx_J_T_check ? "success" : "white"
                            }`}
                        >
                          دۆلار
                        </div>
                        <div className="col-2">
                          <label className="switch">
                            <input
                              type="checkbox"
                              id="toggle"
                              checked={G_Nrx_J_T_check}
                              onChange={OnChangeSwitch_G}
                              disabled={G_del_dis || G_joripara}
                            />
                            <span className="slider round"></span>
                          </label>
                        </div>
                        <div
                          className={`col-1 text-${G_Nrx_J_T_check ? "success" : "white"
                            }`}
                        >
                          دۆلار٢
                        </div>
                        <div
                          className={`col-1 text-${!G_Nrx_IQD_check ? "warning" : "white"
                            }`}
                        >
                          دینار
                        </div>
                        <div className="col-2">
                          <label className="switch">
                            <input
                              type="checkbox"
                              id="toggle"
                              checked={G_Nrx_IQD_check}
                              onChange={OnChangeSwitch_G_IQD}
                              disabled={G_del_dis || G_joripara}
                            />
                            <span className="slider round"></span>
                          </label>
                        </div>
                        <div
                          className={`col-1 text-${G_Nrx_IQD_check ? "warning" : "white"
                            }`}
                        >
                          دینار٢
                        </div>
                      </div>
                    </div>
                    <div className="col-3"></div>
                  </div>
                </div>

                {/* <div className="row text-danger font-weight-bold form-check-inline mb3 bg-warning"  onChange={radiochange}>

                    <div className="b--black text-right col-2 ">
                    {R_error != null && <button className="btn btn-danger text-right" type="button"  >
                    {R_error.msg?R_error.msg :R_error.error[0].msg } 
                  <span className='ml-2  border-black' onClick={()=>R_ClearError()}>X</span></button>}
                  </div>
             </div> */}
                {/* <br/> */}
                {G_search == true ? (
                  <div className="row text-warning font-weight-bold ">
                    <div className="col-sm-2"></div>
                    <div className="col-sm-1"></div>
                    <div className="col-sm-1"></div>
                    <div className="col-sm-1">
                      <h5
                        className="border b--black "
                        style={{ backgroundColor: "#32CD32", color: "#000" }}
                        name="qazanj"
                      >
                        Q$ {G_qazanj}
                      </h5>
                    </div>
                    <div className="col-sm-1">
                      <h5
                        className="border b--black "
                        style={{ backgroundColor: "#32CD32", color: "#000" }}
                        name="rasid"
                      >
                        R {Number(G_rasidKarton).toFixed(2)}
                      </h5>
                    </div>

                    <div className="col-sm-1">
                      <h5
                        className="border b--black bg-white text-dark"
                        name="kren"
                      >
                        K$ {G_kren}
                      </h5>
                    </div>
                    <div className="col-sm-1">
                      <h5
                        className="border b--black bg-white text-dark"
                        name="nrxyakkarton"
                      >
                        KK$ {G_nrxkaton}
                      </h5>
                    </div>

                    <div className="col-sm-1">
                      <h5
                        className="border b--black bg-white text-dark"
                        name="frosthndolar"
                      >
                        $ {G_nrx_dolar}
                      </h5>
                    </div>
                    <div className="col-sm-1">
                      <h6
                        className="border b--black bg-white text-dark"
                        name="frosthndinar"
                      >
                        ID {G_nrx_dinarr}
                      </h6>
                    </div>
                    <div className="col-sm-1">
                      <h6
                        className="border b--black bg-white text-dark"
                        name="niwkarton"
                      >
                        1/2ID {G_nrx_niwkarton}
                      </h6>
                    </div>
                    <div className="col-sm-1">
                      <h6
                        className="border b--black bg-white text-dark"
                        name="Rkmtrladadrzan"
                      >{`>10ID ${G_nrx_kmtrdadarzan}`}</h6>
                    </div>
                  </div>
                ) : null}
                <form>
                  <div
                    className="row text-warning font-weight-bold"
                    style={{ backgroundColor: "#2C3539" }}
                  >
                    <div className="col-1 text-right px-2 mt4">
                      <button
                        onClick={G_createNewPage}
                        disabled={G_table || G_open ? true : null}
                        className={`btn ${G_open || G_table ? "btn-danger" : "btn-primary"
                          } mr2`}
                      >
                        <i className="far fa-file fa-lg"></i>
                      </button>
                      <button
                        onClick={(e) => G_saveDetail(e)}
                        className="btn btn-success"
                      >
                        <i className="far fa-save"></i>
                      </button>
                    </div>

                    <div className="col-2 text-right ">
                      <div className="form-group ">
                        {G_joripara == "دۆلار" ? (
                          <>
                            <label>$ کۆی گشتی </label>
                            <input
                              type="number"
                              disabled={G_del_dis == true ? true : null}
                              value={
                                G_karton > 0 || G_darzan > 0
                                  ? G_getkoygahty(G_darzan, G_karton)
                                  : 0
                              }
                              onChange={AddProChange}
                              onKeyPress={(event) =>
                                event.key == "Enter"
                                  ? G_saveDetail(event)
                                  : null
                              }
                              name="R_koygshty$"
                              className="form-control text-right font-weight-bold tc"
                            />
                          </>
                        ) : (
                          <>
                            <label>ID کۆی گشتی </label>
                            <input
                              type="number"
                              disabled={G_del_dis == true ? true : null}
                              value={
                                G_karton > 0 || G_darzan > 0
                                  ? G_getkoygahty(G_darzan, G_karton)
                                  : 0
                              }
                              onChange={AddProChange}
                              onKeyPress={(event) =>
                                event.key == "Enter"
                                  ? G_saveDetail(event)
                                  : null
                              }
                              name="R_koygshtyID"
                              className="form-control text-right font-weight-bold tc"
                            />
                          </>
                        )}
                      </div>
                    </div>

                    <div className="col-1 text-right px-2">
                      <div className="form-group">
                        <label>ڕێژە</label>
                        <input
                          type="number"
                          disabled={G_del_dis == true ? true : null}
                          value={G_rezha}
                          name="G_rezha"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? G_tofirstInputINRent(event)
                              : null
                          }
                          className="form-control text-right font-weight-bold"
                        />
                      </div>
                    </div>

                    <div className="col-1 text-right px-2">
                      <div className="form-group">
                        <label>نرخ</label>
                        <input
                          type="text"
                          disabled={G_del_dis == true ? true : null}
                          value={G_nrx}
                          onKeyPress={(event) =>
                            event.key == "Enter" ? toanotherInput(event) : null
                          }
                          name="G_nrx"
                          onChange={G_nrxchange}
                          className="form-control text-right font-weight-bold pr-4"
                        />
                      </div>
                    </div>

                    <div className="col-1 text-right px-2">
                      <div className="form-group">
                        <label>دەرزەن</label>
                        <input
                          type="text"
                          disabled={G_del_dis == true ? true : null}
                          onKeyPress={(event) =>
                            event.key == "Enter" ? toanotherInput(event) : null
                          }
                          onChange={(e) => G_DarzanChange(e)}
                          value={G_darzan}
                          name="G_darzan"
                          className="form-control text-right font-weight-bold pr-4"
                        />
                      </div>
                    </div>

                    <div className="col-1 text-right px-2">
                      <div className="form-group">
                        <label>کارتۆن</label>
                        <input
                          type="text"
                          disabled={G_del_dis == true ? true : null}
                          onKeyPress={(event) =>
                            event.key == "Enter" ? toanotherInput(event) : null
                          }
                          onChange={G_CartonChange}
                          value={G_karton}
                          name="G_karton"
                          className="form-control text-right font-weight-bold pr-4"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right">
                      <div className="form-group">
                        <label>ناوی شتەکان</label>
                        <input
                          type="text"
                          disabled={G_del_dis == true ? true : null}
                          value={G_naweSht}
                          name="G_naweSht"
                          onKeyPress={(event) =>
                            event.key == "Enter" ? toanotherInput(event) : null
                          }
                          className="form-control text-right font-weight-bold bg-info text-white"
                        />
                      </div>
                    </div>
                    {/* <div className="col-1 text-right px-2">
                      <div className="form-group">
                        <label>ژ.شتەکان</label>
                        <input
                          type="text"
                          disabled={G_del_dis == true ? true : null}
                          value={G_zhmaraysht}
                          name="G_zhmaraysht"
                          onKeyPress={(event) =>
                            event.key == "Enter" ? toanotherInput(event) : null
                          }
                          className="form-control text-right font-weight-bold bg-info text-white"
                        />
                      </div>
                    </div> */}
                    <div className="col-1 text-right px-2">
                      <div className="form-group">
                        <label>کۆد</label>
                        <input
                          type="text"
                          onClick={G_setSaletSearchEmty}
                          disabled={G_del_dis == true ? true : null}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? G_getProductDataBySearchRent(event)
                              : null
                          }
                          value={G_zhmara}
                          name="G_zhmara"
                          onChange={AddProChange}
                          className="form-control text-right font-weight-bold tc pr-4 bg-info text-white"
                        />
                      </div>
                    </div>
                    <div className="col-1 text-right  mt4">
                      <div className="row">
                        <div className="col-3"></div>
                        <div className="col-6">
                          <button
                            onClick={G_setSaletSearchEmty}
                            className="btn btn-dark"
                          >
                            <i className="fas fa-search-plus"></i>
                          </button>
                        </div>
                        <div className="col-3"></div>
                      </div>
                    </div>
                  </div>
                </form>
              </>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}

export default FillDetailKoga;
